@if (!isChip && !hasIcon) {
  <forge-button [attr.type]="buttonType" [ngClass]="{'tt-margin--right': primary}"
    [ngStyle]="{'color' : !primary ? 'var(--forge-theme-text-high)' : '' }" (click)="execute($event)"
    [disabled]="Disabled" [attr.telemetry]="telemetry" class="metadata-action--button" [attr.dense]="dense ? true : null"
    [attr.forge-ignore]="expansionPanelAction ? 'true' : undefined">
    {{label}}
  </forge-button>
}

@if (!isChip && hasIcon) {
  <forge-icon-button [attr.dense]="dense ? true : null" (click)="execute($event)" [attr.aria-label]="label"
    [disabled]="Disabled" [attr.telemetry]="telemetry" [tabindex]="tabindex" class="metadata-action--button"
    [attr.forge-ignore]="expansionPanelAction ? 'true' : undefined">
    <forge-tooltip placement="bottom">{{label}}</forge-tooltip>
    <forge-icon [attr.name]="Icon"></forge-icon>
  </forge-icon-button>
}

@if (showChip) {
  <forge-chip (click)="execute($event)" [disabled]="Disabled" [attr.telemetry]="telemetry"
    class="tt-margin--right metadata-action--button" [theme]="theme" [attr.dense]="dense ? true : null"
    [attr.forge-ignore]="expansionPanelAction ? 'true' : undefined">
    @if (hasIcon) {
      <forge-icon [attr.name]="Icon" slot="leading"></forge-icon>
    }
    @if (!lazyLoading) {
      <div>{{label}}</div>
    }
    @if (lazyLoading) {
      <forge-skeleton class="document-chip-loading"></forge-skeleton>
    }
  </forge-chip>
}
